import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0708e333"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title sub-title" }, "コンテンツ", -1))
const _hoisted_3 = { class: "table contents" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"10%"},
      class: "number"
    }, "No."),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"%"},
      class: "fileName"
    }, "ファイル名"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "download"
    })
  ])
], -1))
const _hoisted_5 = {
  class: "number",
  "data-cy": "number"
}
const _hoisted_6 = { "data-cy": "fileName" }
const _hoisted_7 = { class: "download" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ダウンロード ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.contents, (data, index) => {
        return (_openBlock(), _createElementBlock("tbody", { key: index }, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_5, _toDisplayString(index + 1), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(data.fileName), 1),
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_AppButton, {
                  onClick: ($event: any) => (_ctx.download(data)),
                  onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.download(data)), ["prevent"]), ["space","enter"]),
                  buttonId: 'button-download'
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onClick", "onKeydown"])
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}